import React from "react";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RouteName } from "../utils/route.utils";
import { teamStructureData } from "../utils/constants/Team";
import events from "../events";
import Head from "next/head";
import TAGS from "../public/headJson.json";
import Footer from "../components/common/Footer";
import TeamAndCulture from "../components/TeamAndCulture";

const Team = (props) => {
  const { webviewEvent } = props;
  const [windowSize, setWindowSize] = useState([]);
  const firebase_uid = useSelector((state) => state?.currentUser?.firebaseUID);

  useEffect(() => {
    if (window) {
      window.dataLayer = window.dataLayer || [];

      const eventParams = {
        firebase_uid,
        url: window.location.href,
        type: "team_page",
        date_time: new Date(),
      };
      if (webviewEvent) {
        eventParams.packageName = webviewEvent?.packageName;
        eventParams.userAgent = webviewEvent?.userAgent;
        eventParams.mobile = webviewEvent?.mobile;
        eventParams.webview = true;
      }
      window.dataLayer.push({
        event: events.WEBPAGE_OPEN,
        ...eventParams,
      });
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setWindowSize(window.innerWidth);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <Head>
        {/* Primary Meta Tags */}
        <title>{TAGS.team.title}</title>
        <meta name="title" content={TAGS.team.title} />
        <meta name="description" content={TAGS.team.description} />
        <link rel="canonical" href={RouteName.team} />

        {/* Facebook / Open Graph */}
        <meta property="og:url" content={RouteName.team} />
        <meta property="og:title" content={TAGS.team.title} />
        <meta property="og:description" content={TAGS.team.description} />
        <meta property="og:image" content={TAGS.landingPage.imageUrl} />
        <meta property="og:image:alt" content="Seekho" />

        {/* Twitter */}
        <meta property="twitter:url" content={RouteName.team} />
        <meta property="twitter:title" content={TAGS.team.title} />
        <meta property="twitter:description" content={TAGS.team.description} />
        <meta property="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@seekhoapp" />
        <meta property="twitter:image" content={TAGS.landingPage.imageUrl} />

        {/* Schema */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(teamStructureData),
          }}
        />
      </Head>

      <main>
        <TeamAndCulture />
        <div>
          <Footer />
        </div>
      </main>
    </>
  );
};

export default Team;
